export default __webpack_public_path__ + "static/media/MichaelCarter.8a8cd80f.png";